  import React from "react";
  import { useSelector } from "react-redux";
  import { Row, Col, Table, Empty } from "antd";
  import { useNavigate } from "react-router-dom";
  import { selectAuthInfo } from "../../../Auth/authSelectors";
  import { useBalanceSheetData } from "./useBalanceSheetData";
  import dayjs from "dayjs";
  import {
    currentDateStartTime,
    currentDateEndTime,
    toCompanyDateOnlyforReportDateFilter,
  } from "../../../../lib/functions";
  import "../../../../components/common/bs.css"

  const fmt = (num) =>
    Number(num || 0).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const BalanceSheetTable = ({ printMode = false }) => {
    const navigate = useNavigate();
    const {
      balances = {},
      loading = false,
      error = null,
      filters = {},
    } = useSelector((state) => state.balanceSheet || {});
    const authInfo = useSelector(selectAuthInfo);
    const institution = useSelector((state) => state.institution?.data);
    const institutionData = useSelector((state) => state.lookups?.institutionData);
    const isIndia = authInfo?.country?.toLowerCase() === "india";
    const taxLabel = isIndia ? "GST" : "VAT";

  const routeMap = {
    "Cash In Hand": "/reports/account-balance",
    "Bank Accounts Balance": "/reports/account-balance",
    "Customer Due Balance": "/reports/debitors-balance",
    "Fixed Assets": "/reports/fixed-asset-balance",
    "Intangible Assets": "/reports/intangible-asset",
    "Advance Payment to Supplier": "/reports/advance-creditor-balance",
    "Receivable From Other Branches": "/reports/branch-tran-receive-list",
    "Transfer Product Value To Other Branches": "/reports/branch-tran-transfer-list",
    "Closing Product Inventory/ Stock Value": "/reports/item-stock-report",
    "Investments": "/reports/investment-balance",
    "Deposit Account": "/reports/deposit-account-report",
    "Current Assets": "/reports/current-assets-report",
    "Suspense Account": "/reports/suspense-balance",
    "Supplier Due Balance": "/reports/creditors-balance",
    "Capital Account": "/reports/capitals-balance",
    "Reserve Surplus Account": "/reports/reserve-surplus-balance",
    "Loan (Liability)": "/reports/loan-balance",
    "Advance Received From Customer": "/reports/advance-debtor-balance",
    "Received Product Value From Branches": "/reports/branch-tran-receive-list",
    "VAT Account": "/reports/tax-ledger",
    "GST Account": "/reports/tax-ledger",
    "Current Liability Balance": "/reports/current-liablity-report",
    "Profit/ Loss": "/reports/profit-loss",
    "Difference In Opening": null,
    "Liabilities (Total)": null,
    "Assets (Total)": null,
  };

    const diffValue = Math.abs(Number(balances.diffOpeningBalance || 0));
    const suspense = Number(balances.suspenseBalance || 0);
    const { liabilities, assets, currency } = useBalanceSheetData();

    if (!loading && error) {
      return (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={error}
          style={{ padding: "48px 0" }}
        />
      );
    }

    const columns = [
      {
        title: "PARTICULARS",
        dataIndex: "label",
        key: "label",
        render: (text, record) => (
          <span style={{
            fontWeight: record.isSection ? 700 : record.strong ? 700 : 500,
            color: record.isSection ? "#1677ff" : "inherit",
            paddingLeft: record.isSection ? 0 :  record.indent ? "24px" : "8px",
        }}>
          {text}
        </span>
      ),
      },
      {
        title: printMode ? "" : "Amount",
        dataIndex: "value",
        key: "value",
        align: "right",
        render: (val, record) => {
          if (record.isSection) return null;
          return record.strong ? (
            <strong>{authInfo.currency ?? ""} {fmt(val)}</strong>
          ) : (
            <>{authInfo.currency ?? ""} {fmt(val)}</>
          );
        },
      },
    ];
    //         paddingLeft: record.isSection
    //           ? 0
    //           : record.indent
    //           ? "24px"
    //           : "8px",
    //       }}>
    //         {text}
    //       </span>
    //     ),
    //   },
    //   {
    //     title: printMode ? "" : "Amount",
    //     dataIndex: "value",
    //     key: "value",
    //     align: "right",
    //     render: (val, record) => {
    //       console.log(record.key, "=>", val);  // ðŸ”¥ add this
    //       if (record.isSection) return null;
    //       return record.strong ? (
    //         <strong>{authInfo.currency ?? ""} {fmt(val)}</strong>
    //       ) : (
    //         <>{authInfo.currency ?? ""} {fmt(val)}</>
    //       );
    //     },
    //   },
    // ];

    const handleRowClick = (record) => {
      if (record.isSection) return;
      const route = routeMap[record.label];
      let key = filters.toDate;
      let startKey = filters.fromDate;

     if (filters.filterType === "Financial Year") {
  const fyYear = Number(filters.fyYear);

  const startMonth = institution?.fy_start_month || 1;

  const endMonth = startMonth === 1 ? 12 : startMonth - 1;

  const endYear = startMonth === 1 ? fyYear : fyYear + 1;

  const lastDay = new Date(endYear, endMonth, 0).getDate();

  key = currentDateEndTime(
    dayjs(
      `${endYear}-${String(endMonth).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`
    )
  );

  startKey = currentDateStartTime(
    dayjs(`${fyYear}-${String(startMonth).padStart(2, "0")}-01`)
  );
}

      // Date Wise: the Balance Sheet API is called with fromDate = null, and the
      // backend (get-balance-sheet) then fills in the company's migration date as
      // From — so every figure is "migration date -> selected date" (Profit/Loss
      // alone starts at the financial-year start). filters.fromDate here is only
      // the default (today), so forwarding it would show today -> selected date
      // and an empty window. Send the same range the Balance Sheet itself used.
      if (filters.filterType === "Date Wise" && key) {
        if (record.label === "Profit/ Loss") {
          const ref = toCompanyDateOnlyforReportDateFilter(key);
          const fyStartMonth = institution?.fy_start_month || 1;
          const fyStartYear =
            ref.month() + 1 >= fyStartMonth ? ref.year() : ref.year() - 1;
          startKey = currentDateStartTime(
            dayjs(`${fyStartYear}-${String(fyStartMonth).padStart(2, "0")}-01`)
          );
        } else {
          const booksStart = institutionData?.migration_date
            ? dayjs(institutionData.migration_date)
            : toCompanyDateOnlyforReportDateFilter(institutionData?.created_date);
          startKey = booksStart ? currentDateStartTime(booksStart) : null;
        }
      }

      if (route) {
        if (key) {
          const query = startKey
            ? `?fromDate=${encodeURIComponent(startKey)}`
            : "";
          navigate(`${route}/${key}${query}`);
        } else {
          navigate(route);
        }
      }
    };


//
    if (printMode) {
  return (
    <table className="bs-print-table">
       <colgroup>
    <col style={{ width: "40%" }} />   {/* Liabilities label */}
    <col style={{ width: "22%"  }} />   {/* Amount */}
    <col style={{ width: "40%" }} />   {/* Assets label */}
    <col style={{ width: "22%"  }} />   {/* Amount */}
  </colgroup>
      <tbody>
        <tr className="bs-print-heading">
          <td>LIABILITIES</td><td style={{textAlign:"right"}}>Amount</td>
          <td>ASSETS</td><td style={{textAlign:"right"}}>Amount</td>
        </tr>
        {Array.from({ length: Math.max(liabilities.length, assets.length) }).map((_, i) => {
          const l = liabilities[i], a = assets[i];
          return (
            <tr key={i}
                className={(l?.isSection || a?.isSection) ? "bs-print-section"
                          : (l?.strong || a?.strong) ? "bs-print-total" : ""}>
              <td>{l?.label ?? ""}</td>
              <td style={{textAlign:"right"}}>
                {l && !l.isSection ? `${authInfo.currency ?? ""} ${fmt(l.value)}` : ""}
              </td>
              <td>{a?.label ?? ""}</td>
              <td style={{textAlign:"right"}}>
                {a && !a.isSection ? `${authInfo.currency ?? ""} ${fmt(a.value)}` : ""}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}

    return (
      <Row gutter={16}>
        <Col xs={24} md={12}>
          <Table
            rowKey="key"
            columns={columns}
            dataSource={liabilities}
            loading={loading}
            pagination={false}
            bordered
            size={printMode ? "small" : "middle"}
            rowClassName={(record) => record.isSection ? "bs-section-row" : ""}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
              style: {
                cursor: (!record.isSection && routeMap[record.label]) ? "pointer" : "default",
              },
            })}
          />
        </Col>
        <Col xs={24} md={12}>
          <Table
            rowKey="key"
            columns={columns}
            dataSource={assets}
            loading={loading}
            pagination={false}
            bordered
            size={printMode ? "small" : "middle"}
            rowClassName={(record) => record.isSection ? "bs-section-row" : ""}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
              style: {
                cursor: (!record.isSection && routeMap[record.label]) ? "pointer" : "default",
              },
            })}
          />
        </Col>
        <style>{`
          .bs-section-row td {
            background-color: #f0f5ff !important;
          }
        `}</style>
      </Row>
    );
  };

  export default BalanceSheetTable;